import { TvSwiper } from './libs/swiper';
import { ImageZoom } from './libs/ImageZoom';

document.addEventListener('DOMContentLoaded', function () {
  const imageZoom = new ImageZoom();
  const tvSwiper = new TvSwiper('.js-tv-swiper');
});
